import React from 'react'
import { Checkbox, Flex, Text } from 'components/ds'

type CheckboxRowProps = {
  checked: boolean | 'indeterminate'
  disabled?: boolean
  onCheckedChange: (checked: string | boolean) => void
  onClick: (event: React.MouseEvent) => void
  children: React.ReactNode
  className?: string
}

/**
 * Shared checkbox row component used across different filter forms.
 * Provides consistent styling and behavior for checkbox interactions.
 */
const CheckboxRow = ({
  checked,
  onCheckedChange,
  onClick,
  children,
  className,
  disabled = false,
}: CheckboxRowProps) => (
  <Flex
    className={className}
    gap="2"
    direction="row"
    onClick={onClick}
    style={{ cursor: 'pointer' }}
  >
    <Text size="2">
      <Flex gap="2" align="center">
        <Checkbox
          checked={checked}
          disabled={disabled}
          onCheckedChange={onCheckedChange}
        />
        {children}
      </Flex>
    </Text>
  </Flex>
)

export default CheckboxRow
